/**
 * Whether the showcase truncates its grid behind a "Show More" / "Show Less" control.
 *
 * Off for now: every community card is shown by default and the control is not rendered.
 * The truncation, per-breakpoint counts, expand tracking, and the control itself are all
 * still in `community-showcase.react-component.tsx` — flip this to `true` to bring them
 * back.
 */
export const IS_REVEAL_ENABLED = false;
